import classNames from 'classnames';
import React from 'react';

interface ContainerProps {
  type?: keyof typeof types;
  xType?: keyof typeof types;
  yType?: keyof typeof types;
  background?: string;
  full?: boolean;
  tag?: keyof JSX.IntrinsicElements;
  children: React.ReactNode;
  className?: string;
}

// Corresponding Figma Tokens
const types = {
  none: '',
  default: 'px-4 sm:px-6 md:px-8 lg:px-10',
  'padding-x-y-sm':
    'px-4 sm:px-6 md:px-8 lg:px-10 py-3 sm:py-3 md:py-4 lg:py-4',
  'padding-y-sm': 'py-3 sm:py-3 md:py-4 lg:py-4',
  'padding-xy-sm': 'px-3 sm:px-3 md:px-4 lg:px-4 py-3 sm:py-3 md:py-4 lg:py-4',
  'padding-xy': 'px-4 sm:px-4 md:px-6 lg:px-6 py-4 sm:py-4 md:py-6 lg:py-6',
  'gap-xy': 'px-4 sm:px-4 md:px-6 lg:px-6 py-4 sm:py-4 md:py-6 lg:py-6',
  sm: 'px-3 sm:px-3 md:px-4 lg:px-4 py-3 sm:py-3 md:py-4 lg:py-4',
  xs: 'px-1 sm:px-2 md:px-3 lg:px-3 py-1 sm:py-2 md:py-3 lg:py-3',
  'padding-x-gap-y': 'px-4 md:px-6 py-4 md:py-6',
  'padding-x': 'px-4 md:px-6',
  'padding-y': 'py-4 md:py-6',
  'section-x-gap-y':
    'px-4 sm:px-6 md:px-8 lg:px-10 pt-4 pb-6 sm:pt-6 sm:pb-8 md:pt-7 md:pb-10 lg:pt-8 lg:pb-12',
  'card-x': 'px-4 md:px-6',
  'card-y': 'px-4 md:px-6',
  'section-x': 'px-4 sm:px-6 md:px-8 lg:px-10',
  'section-y': 'py-4 sm:py-6 md:py-7 lg:py-8',
  'section-xy': 'px-4 sm:px-6 md:px-8 lg:px-10 py-4 sm:py-6 md:py-7 lg:py-8',
  'padding-td': 'px-4 sm:px-6 py-6',
  section: 'px-4 sm:px-6 md:px-8 lg:px-10 py-6 sm:py-8 md:py-10 lg:py-12',
} as const;

export const Container: React.FC<ContainerProps> = ({
  type = 'none',
  xType,
  yType,
  background = 'bg-transparent',
  full = false,
  tag: Tag = 'section',
  children,
  className,
}) => {
  const getClasses = () => {
    const classList = [
      background,
      xType && types[xType],
      yType && types[yType],
      type && types[type],
      full && '!px-0',
      className,
    ].filter(Boolean);

    return classNames(classList);
  };

  return <Tag className={getClasses()}>{children}</Tag>;
};
